import * as React from 'react';
import { css } from 'aphrodite';
import styles from 'login-components/Common/svg/SVGStyles';

export default class SpecialtyVehicleBoatRefinanceSVG extends React.PureComponent {
  render() {
    return (
      <svg
        className={css(styles.width)}
        height="100px"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 100 100"
        focusable="false"
      >
        <g>
          <path
            className={css(styles.action)}
            d="M33.114,38.873,20.986,55.523l21.583.2L53.053,38.873Zm5.435,4.159,1.9-.008a.636.636,0,0,1,.005,1.272l-1.9.008a.636.636,0,0,1-.006-1.272Zm-5.4.026,1.9-.009a.636.636,0,0,1,.006,1.272l-1.9.009a.636.636,0,1,1-.005-1.272ZM30.33,51l-1.9.008a.636.636,0,0,1,0-1.272l1.9-.008a.636.636,0,0,1,0,1.272Zm.6-3.38a.636.636,0,1,1-.006-1.272l1.9-.008a.636.636,0,1,1,0,1.272Zm4.808,3.354-1.9.008a.636.636,0,1,1-.006-1.271l1.9-.009a.636.636,0,1,1,0,1.272Zm.6-3.379a.636.636,0,1,1-.005-1.272l1.9-.009a.636.636,0,1,1,.006,1.272Zm4.809,3.353-1.9.009a.636.636,0,0,1-.006-1.272l1.9-.009a.636.636,0,1,1,.006,1.272Zm2.491-3.387-1.9.008a.636.636,0,0,1-.005-1.272l1.9-.008a.636.636,0,0,1,.005,1.272Zm2.226-3.292-1.9.008a.636.636,0,0,1-.006-1.272l1.9-.008a.636.636,0,1,1,.005,1.272Z"
          />
          <path
            className={css(styles.actionAccent)}
            d="M26.75,69.95l13.1-14.606,53.075-.886a1,1,0,0,1,.789,1.622c-2.825,3.453-7.3,11.128-20.313,12.854C58.375,70.928,26.75,69.95,26.75,69.95Z"
          />
          <rect className={css(styles.white)} x="14.892" y="56.634" width="25.099" height="13.542" />
          <path
            className={css(styles.action)}
            d="M37.433,59.192v8.426H17.45V59.192H37.433m2.558-2.558h-25.1V70.176h25.1V56.634Z"
          />
          <rect className={css(styles.actionAccent)} x="24.584" y="67.899" width="12.838" height="2.282" />
          <rect className={css(styles.actionAccent)} x="24.584" y="63.335" width="12.838" height="2.282" />
          <rect className={css(styles.grey)} x="24.584" y="65.617" width="12.838" height="2.282" />
          <path
            className={css(styles.action)}
            d="M33.817,61.3H8.9a.088.088,0,0,0-.093.081V70.1a.088.088,0,0,0,.093.081H33.817a.088.088,0,0,0,.093-.081V61.379A.088.088,0,0,0,33.817,61.3Z"
          />
          <rect
            className={css(styles.white)}
            x="17.867"
            y="64.794"
            width="6.988"
            height="1.891"
            rx="0.946"
            transform="translate(42.721 131.479) rotate(180)"
          />
          <path
            className={css(styles.grey)}
            d="M93.031,53.673h-6.1l-1.865-1.8a9.116,9.116,0,0,0-5.648-1.942c-2.012,0-2.826-1.329-4.136-2.857l-5.756-6.973h1.667a1.491,1.491,0,0,0,1.487-1.486v-.11a1.491,1.491,0,0,0-1.487-1.487H31.62a1.491,1.491,0,0,0-1.487,1.487v.11a1.491,1.491,0,0,0,1.487,1.486H59.254l-8.5,13.567H15.116a1.491,1.491,0,0,0-1.486,1.486v.111a1.491,1.491,0,0,0,1.486,1.486H93.031a1.49,1.49,0,0,0,1.486-1.486v-.111A1.49,1.49,0,0,0,93.031,53.673Zm-27.219,0H53.687l7.642-12.2a40.834,40.834,0,0,1,3.764,3.917C66.6,47.267,66.081,51.887,65.812,53.673Z"
          />
          <polygon
            className={css(styles.actionAccent)}
            points="39.893 37.374 33.705 37.374 33.705 29.81 48.145 29.81 48.145 37.374 41.956 37.374 41.956 40.125 39.893 40.125 39.893 37.374"
          />
          <rect className={css(styles.grey)} x="35.768" y="31.873" width="10.314" height="3.438" />
          <polygon
            className={css(styles.action)}
            points="69.485 40.055 63.848 40.055 71.898 49.336 77.465 49.336 69.485 40.055"
          />
          <path
            className={css(styles.grey)}
            d="M39.967,70.184s9.264.1,12.7-1.619a11.056,11.056,0,0,1,10.357.059c3.277,1.716,4.408-1.073,7.373.175.773.325,2.545.384,6.378-1.287,2.282-1,3.656-1.63,4.681-.312,1.093,1.4-.507,2.887-.507,2.887Z"
          />
        </g>
      </svg>
    );
  }
}
